import { useEffect } from "react";

/**
 * Sets this page's real <title> and meta-description once it mounts.
 *
 * React Router is a client-side router, so navigating between pages
 * never triggers a real document load — the <title> and
 * meta[name=description] set in public/index.html (or by whichever
 * page rendered last) just sit there untouched. That's why every
 * route on this site has shared one title/description in search and
 * AI results instead of each page describing itself.
 *
 * Call with this page's real title and description; pass undefined
 * for either one to leave it as whatever is already set.
 */
export function useSEO(title, description) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);
}
